/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Debt_Ledger_Pay_BtnInputs */

const vi_customer_debt_ledger_pay_btn = /** @type {(inputs: Customer_Debt_Ledger_Pay_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán`)
};

/**

* @param {Customer_Debt_Ledger_Pay_BtnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_debt_ledger_pay_btn = /** @type {((inputs?: Customer_Debt_Ledger_Pay_BtnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Debt_Ledger_Pay_BtnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_debt_ledger_pay_btn(inputs)
});